import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-family-retreat-contemplation',
  templateUrl: './family-retreat-contemplation.component.html',
  styleUrls: ['./family-retreat-contemplation.component.scss']
})
export class FamilyRetreatContemplationComponent {

  @Output() formGroupChange = new EventEmitter<FormGroup>();
  @Output() nextStep = new EventEmitter<void>();
  @Output() previous = new EventEmitter<void>();

  siddhaYogaFamilyRetreatForm!: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.siddhaYogaFamilyRetreatForm = this.fb.group({
      childBehaviorChanges: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      parentInsights: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      siddhaYogaMessage: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      siddhaYogaPractices: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      purposeParticipation: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
      contribution: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(5000)]],
    });

    this.formGroupChange.emit(this.siddhaYogaFamilyRetreatForm);
  }

  onSubmit() {
    this.submitted = true;
    if (this.siddhaYogaFamilyRetreatForm.valid) {
      this.nextStep.emit();
    }
  }

  goToBack() {
    this.previous.emit();
  }
}